import { render, staticRenderFns } from "./ViewSchemePlanProperties.vue?vue&type=template&id=1dd8a49b"
import script from "./ViewSchemePlanProperties.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSchemePlanProperties.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports